import { ArrowRight } from "lucide-react";
import { Button } from "./ui/Button";
import AuthRedirect from "./AuthRedirect";

export const CTA = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 gradient-primary opacity-10" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-primary/20 blur-3xl animate-float" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          {/* Icon */}
          <div className="inline-flex w-20 h-20 items-center justify-center mx-auto">
            <img 
              src="/gabi.png" 
              alt="GABI" 
              className="w-full h-full object-contain"
            />
          </div>

          <h2 className="text-4xl md:text-6xl font-bold">
            ¿Listo para encontrar{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary via-accent to-primary">
              tu casa sin perder la cabeza?
            </span>{" "}
            🏠
          </h2>

          <p className="text-xl text-muted-foreground">
            Únete a cientos de compradores que ya están usando GABI para entender qué pueden comprar, cómo hacerlo y qué alternativas reales tienen.
          </p>

          <div className="flex justify-center">
            <AuthRedirect>
              <Button variant="hero" size="xl" className="gap-2 w-full sm:w-auto">
                👉 Empieza ahora gratis
                <ArrowRight className="w-5 h-5" />
              </Button>
            </AuthRedirect>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 pt-12 border-t border-border/50">
            <div>
              <div className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
                +500
              </div>
              <div className="text-sm text-muted-foreground mt-1">anuncios analizados</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
                98%
              </div>
              <div className="text-sm text-muted-foreground mt-1">de satisfacción</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
                24/7
              </div>
              <div className="text-sm text-muted-foreground mt-1">Disponible</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
